import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CloseIcon, DeleteIcon } from "@icarius-icons";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import { getGalleryImages, getIsLoading } from "../selectors";
import { deleteImageAction, getGalleryImagesAction, uploadImageAction } from "../actions";
import ImageGrid from "./imageGrid";
import ImageInput from "./imageInput";
import Loader from "@icarius-common/loader";

const Container = ({ children }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
    {children}
  </div>
)

const GalleryDialog = (props) => {

  const {
    open,
    type = "news",
    initialValue,
    handleSubmit,
    handleClose,
  } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGalleryImagesAction(type))
  }, [dispatch, type])

  const images = useSelector(getGalleryImages);
  const isLoading = useSelector(getIsLoading);
  const [selectedImagePath, setSelectedImagePath] = useState(initialValue || "");

  const selectedImageCanBeDeleted = images.find((image) => image.img === selectedImagePath)?.canDelete;

  const uploadImageToGallery = (file) => {
    setSelectedImagePath("");
    dispatch(uploadImageAction(file, type));
  }

  const deleteImageFromGallery = (filename) => {
    setSelectedImagePath("");
    dispatch(deleteImageAction(filename, type));
  }

  const submit = () => {
    handleSubmit(selectedImagePath);
    handleClose();
  }

  return (
    <Dialog open={open} TransitionComponent={DialogTransition} PaperComponent={PaperDraggable} fullWidth maxWidth={"lg"} >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {getLocalizedString("groupImagesTitle")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent>
        <Loader open={isLoading} />
        <ImageGrid
          images={images}
          selectedImage={selectedImagePath}
          handleSelect={(newImagePath) => setSelectedImagePath((prev) => prev !== newImagePath ? newImagePath : "")}
        />
      </DialogContent>
      <div style={{ margin: "40px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Container>
          <ImageInput handleUploadImage={uploadImageToGallery} />
          {
            selectedImageCanBeDeleted &&
            <IconButton onClick={() => deleteImageFromGallery(selectedImagePath)} >
              <DeleteIcon fontSize="small" />
            </IconButton>
          }
        </Container>
        <Container>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
          <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("save")} />
        </Container>
      </div>
    </Dialog>
  )
}

export default GalleryDialog;